import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"

vue.use(vuex);

const Serie = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/serie`,
    state: {
        ListaSeries: []        
    }
}).get({
    action: "get_series", 
    path: function (obj) {
        return `lista/${obj.idindicador}`;
    },
    onSuccess: (state, payload) => {
        state.ListaSeries = payload.data;
    }
}).get({
    action: "get_generar", 
    path: function (obj) {
        return `generar/${obj.idindicador}`;
    },      
    onSuccess: (state, payload) => {
        state.ListaSeries = payload.data;
    },
    onError: (state, error) => { 
        store.dispatch("mensaje/set_error", error);
    }    
}).get({
    action: "get_addnuevaserie", 
    path: function (obj) {
        return `addnuevaserie/${obj.idindicador}/${obj.anoserieup}/${obj.up}`;
    },      
    onSuccess: (state, payload) => {
        state.ListaSeries = payload.data;
    },
    onError: (state, error) => { 
        store.dispatch("mensaje/set_error", error);
    }    
}).get({
    action: "get_deletenuevaserie", 
    path: function (obj) {
        return `deletenuevaserie/${obj.idindicador}/${obj.anoserieup}/${obj.up}`;
    },      
    onSuccess: (state, payload) => {
        state.ListaSeries = payload.data;
    },
    onError: (state, error) => { 
        store.dispatch("mensaje/set_error", error);
    }    
}) .getStore();

Serie.getters = {
    gseries: state => {
        return state.ListaSeries
    }
}

export default Serie;